module.exports = __webpack_public_path__ + "static/media/image01.f64245cf.png";